import React, {useEffect, useState} from 'react';
import TeacherLayout from "@/components/layout/teacher/teacherLayout";
import {URLS} from "@/lib/urls";
import {useApiSearchTeacherLessons} from "@/api/lesson";
import RenderIf from "@/components/render-if";
import {Col, Empty, Row, Segmented, Spin} from "antd";
import {TeacherLessonCard} from "@/pages/teacher/lessons/dashboard/_section/TeacherLessonCard";
import PaginationRaw from "@/components/pagination/PaginationRaw";
import SearchInputRaw from "@/components/search/SearchInputRaw";
import {useSearchParams} from "react-router-dom";

function TeacherLessonListPage(props) {
    const [search, setSearch] = useState()
    const [page, setPage] = useState(1)
    const [perPage, setPerPage] = useState(15)
    const [activeLesson, setActiveLesson] = useState('active')
    const [searchParams, setSearchParams] = useSearchParams();

    const {data, isPending} = useApiSearchTeacherLessons({
        page: page,
        per_page: perPage,
        search: search,
        filter: activeLesson
    });

    useEffect(() => {
        if (searchParams.get('filter')) {
            setActiveLesson(searchParams.get('filter'));
        }
    }, [searchParams.get('filter')])

    return (
        <>
            <TeacherLayout pageTitle={'لیست درس‌های من'} backTo={URLS.teacher.dashboard}>
                <div className={'mb-2'}>
                    <div className="flex flex-wrap gap-2 justify-between">

                        <SearchInputRaw setSearch={setSearch} setPage={setPage}
                                        placeHolder={'جستجو در لیست درس‌های من ...'}/>
                        <div>
                            <Segmented

                                value={activeLesson}
                                options={[
                                    {label: 'درس‌های امروز', value: 'today'},
                                    {label: 'درس‌های فعال', value: 'active'},
                                    {label: 'همه درس‌ها', value: 'all'},
                                ]}
                                onChange={(value) => {
                                    setActiveLesson(value);
                                }}
                            />
                        </div>
                    </div>
                </div>

                <RenderIf condition={isPending}>
                    <Spin spinning={true}></Spin>
                </RenderIf>

                <RenderIf condition={data?.data?.data?.length === 0}>
                    <Empty description={'نتیجه‌ای یافت نشد'}></Empty>
                </RenderIf>


                <Row gutter={[8, 8]}>
                    {data?.data?.data?.map((item, index) => (
                        <Col
                            span={8}
                            xs={24}
                            sm={24}
                            md={12}
                            lg={12}
                            xl={8}
                            key={'my-teacher-lesson' + index + '-id-' + item.id}>
                            <TeacherLessonCard lesson={item}/>
                        </Col>
                    ))}

                </Row>

                <PaginationRaw data={data?.data} setPage={setPage} setPerPage={setPerPage}/>


            </TeacherLayout>
        </>

    );

}

export default TeacherLessonListPage;